/* eslint-disable */

import dicts from './example'
// import cache from '../../../utils/cache'

// 支部党员发展情况(本年度正在发展的新党员)
export const branchWorkRecordCols = [
  {
    title: '姓名',
    key: 'name',
    tooltip: true,
    minWidth: 150,
  },
  {
    title: '性别',
    slot: 'gender',
    width: 100,
  },
  {
    title: '年龄',
    key: 'age',
    width: 100,
    tooltip: true,
  },
  {
    title: '工作单位及职务',
    key: 'workJob',
    width: 140,
  },
  {
    title: '联系电话',
    key: 'phone',
    width: 160,
  },
  {
    title: '界别',
    slot: 'socialRelationship',
    width: 160,
  },
  {
    title: '是否高中级知识分子',
    slot: 'isElite',
    width: 160,
  },
  {
    title: '联系人',
    key: 'contactName',
    width: 160,
  },
  {
    title: '发展阶段',
    slot: 'stage',
    width: 160,
  },
  {
    title: '备注',
    key: 'remark',
    width: 160,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchWorkRecordForm = {
  attrs: {
    labelWidth: '180px',
    'label-position': 'left',
    // rules: {
    //   name: [
    //     { required: true, message: '请输入姓名', trigger: 'blur' },
    //   ],
    //   gender: [
    //     { required: true, message: '请选择性别', trigger: 'change' },
    //   ],
    //   birthday: [
    //     {
    //       required: true,
    //       message: '请选择出生日期',
    //       trigger: 'change',
    //     },
    //   ],
    //   workJob: [
    //     {
    //       required: true,
    //       message: '请输入工作单位及职务',
    //       trigger: 'blur',
    //     },
    //   ],
    //   phone: [
    //     { required: true, message: '请输入联系方式', trigger: 'blur' },
    //   ],
    //   socialRelationship: [
    //     {
    //       required: true,
    //       message: '请选择界别',
    //       trigger: 'change',
    //     },
    //   ],
    //   isElite: [
    //     {
    //       required: true,
    //       message: '请选择是否高中级知识分子',
    //       trigger: 'change',
    //     },
    //   ],
    //   contactName: [
    //     { required: true, message: '请输入联系人', trigger: 'blur' },
    //   ],
    //   stage: [
    //     {
    //       required: true,
    //       message: '请选择发展阶段',
    //       trigger: 'change',
    //     },
    //   ],
    //   remark: [
    //     {
    //       required: true, message: '请输入备注', trigger: 'blur'
    //     }
    //   ]
    // },
  },
  items: [
    {
      label: '姓名',
      prop: 'name',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '性别',
      prop: 'gender',
      options: dicts.gender(),
    },
    {
      type: 'datepicker',
      label: '出生日期',
      prop: 'birthday',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
      attrs: {
        options: {
          disabledDate: date => {
            return date && date.valueOf() > Date.now() - 86400000
          },
        },
      },
    },
    {
      label: '工作单位及职务',
      prop: 'workJob',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '联系方式',
      prop: 'phone',
      maxlength: 30,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '界别',
      prop: 'socialRelationship',
      options: dicts.circles(),
    },
    {
      type: 'select',
      label: '是否高中级知识分子',
      prop: 'isElite',
      options: dicts.whether(),
    },
    {
      label: '联系人',
      prop: 'contactName',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '发展阶段',
      prop: 'stage',
      options: dicts.stage(),
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}

// 发展新党员信息(本年度已发展的新党员)
export const branchWorkRecordDevelopedCols = [
  {
    title: '新党员姓名',
    key: 'name',
    tooltip: true,
    width: 120,
  },
  {
    title: '介绍人姓名',
    key: 'referenceName',
    tooltip: true,
    width: 140,
  },
  {
    title: '入党前有无参加支部活动',
    slot: 'eventBefore',
    width: 240,
  },
  {
    title: '支部大会通过入党申请时间',
    key: 'passTime',
    width: 240,
    tooltip: true,
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 160,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchWorkRecordDevelopedForm = {
  attrs: {
    labelWidth: '200px',
    'label-position': 'left',
    // rules: {
    //   name: [
    //     { required: true, message: '请输入党员姓名', trigger: 'blur' },
    //   ],
    //   referenceName: [
    //     {
    //       required: true,
    //       message: '请输入介绍人姓名',
    //       trigger: 'blur',
    //     },
    //   ],
    //   eventBefore: [
    //     {
    //       required: true,
    //       message: '请选择入党前有无参加支部活动',
    //       trigger: 'change',
    //     },
    //   ],
    //   passTime: [
    //     {
    //       required: true,
    //       message: '请输入支部大会通过入党申请时间',
    //       trigger: 'blur',
    //     },
    //   ],
    //   remark: [
    //     {
    //       required: true, message: '请输入备注', trigger: 'blur'
    //     }
    //   ]
    // },
  },
  items: [
    {
      label: '新党员姓名',
      prop: 'name',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '介绍人姓名',
      prop: 'referenceName',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '入党前有无参加支部活动',
      prop: 'eventBefore',
      options: [
        { label: '无', value: 0 },
        { label: '有', value: 1 },
      ],
    },
    {
      label: '支部大会通过入党申请时间',
      prop: 'passTime',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
      placeholder: '格式如: 2023年23届15次',
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}

// 支部党员关系转移记录
export const branchWorkRecordTransferCols = [
  {
    title: '党员姓名',
    key: 'name',
    tooltip: true,
    minWidth: 150,
  },
  {
    title: '党籍编号',
    key: 'number',
    tooltip: true,
    minWidth: 150,
  },
  {
    title: '转入/转出',
    slot: 'transferType',
    width: 100,
  },
  {
    title: '转入/转出时间',
    key: 'transferTime',
    width: 140,
    tooltip: true,
  },
  {
    title: '由何地转入/转出到何地',
    key: 'details',
    width: 190,
    tooltip: true,
  },
  {
    title: '备注',
    key: 'remark',
    width: 160,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchWorkRecordTransferForm = {
  attrs: {
    labelWidth: '180px',
    'label-position': 'left',
    // rules: {
    //   userUid: [
    //     { required: true, message: '请输入党员姓名', trigger: 'blur' },
    //   ],
    //   number: [
    //     {
    //       required: true,
    //       message: '请输入党籍编号',
    //       trigger: 'blur',
    //     },
    //   ],
    //   transferType: [
    //     {
    //       required: true,
    //       message: '请选择转入/转出',
    //       trigger: 'change',
    //     },
    //   ],
    //   transferTime: [
    //     {
    //       required: true,
    //       message: '请选择转入/转出时间',
    //       trigger: 'change',
    //     },
    //   ],
    //   details: [
    //     {
    //       required: true,
    //       message: '请输入由何地转入转出到何地',
    //       trigger: 'blur',
    //     },
    //   ],
    //   remark: [
    //     {
    //       required: true, message: '请输入备注', trigger: 'blur'
    //     }
    //   ]
    // },
  },
  items: [
    {
      type: 'select-remote-input',
      showType: 'select',
      label: '党员姓名',
      prop: 'userId',
      filterable: true,
      remote: true,
      paramsKey: 'name',
      remoteAction: 'getMemberListApi',
      labelName: 'name',
      valueName: 'id',
      maxlength: 20,
      showWordLimit: true,
      filterable: true,
      clearable: true
    },
    {
      label: '党籍编号',
      prop: 'number',
      maxlength: 11,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '转入/转出',
      prop: 'transferType',
      options: dicts.transferType(),
    },
    {
      type: 'datepicker',
      label: '转入/转出时间',
      prop: 'transferTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      label: '由何地转入转出到何地',
      prop: 'details',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}

// 支部党员推荐情况
export const branchWorkRecordSuggestCols = [
  {
    title: '时间',
    key: 'suggestedTime',
    tooltip: true,
    width: 150,
  },
  {
    title: '被推荐人员',
    key: 'suggestedName',
    tooltip: true,
    width: 150,
  },
  {
    title: '被推荐参加何种活动/会议/培训',
    key: 'suggestedEvent',
    width: 300,
  },
  {
    title: '是否入选',
    slot: 'isSelected',
    width: 100,
    tooltip: true,
  },
  {
    title: '是否有推荐党员作为后备干部人选',
    slot: 'isSuggested',
    width: 300,
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 160,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchWorkRecordSuggestForm = {
  attrs: {
    labelWidth: '240px',
    'label-position': 'left',
    rules: {
      suggestedTime: [
        {
          required: true,
          message: '请选择时间',
          trigger: 'change',
        },
      ],
      suggestedName: [
        { required: true, message: '请输入被推荐人员', trigger: 'blur' },
      ],
      suggestedEvent: [
        {
          required: true,
          message: '请输入推荐参加何种活动/会议/培训',
          trigger: 'blur',
        },
      ],
      isSelected: [
        {
          required: true,
          message: '请选择是否入选',
          trigger: 'change',
        },
      ],
      isSuggested: [
        {
          required: true,
          message: '请选择是否有推荐党员作为后备干部人选',
          trigger: 'change',
        },
      ]
    },
  },
  items: [
    {
      type: 'datepicker',
      label: '时间',
      prop: 'suggestedTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      label: '被推荐人员',
      prop: 'suggestedName',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '推荐参加何种活动/会议/培训',
      prop: 'suggestedEvent',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '是否入选',
      prop: 'isSelected',
      options: dicts.whether(),
    },
    {
      type: 'select',
      label: '是否有推荐党员作为后备干部人选',
      prop: 'isSuggested',
      options: dicts.whether(),
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}

// 支部(党员)参加上级工作记录
export const branchWorkRecordAttendCols = [
  {
    title: '时间',
    key: 'attendTime',
    tooltip: true,
    width: 150,
  },
  {
    title: '活动内容',
    key: 'content',
    tooltip: true,
    width: 150,
  },
  {
    title: '类别',
    slot: 'attendType',
    minWidth: 180,
  },
  {
    title: '参加人员',
    slot: 'userType',
    width: 150,
    tooltip: true,
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 160,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchWorkRecordAttendForm = {
  attrs: {
    labelWidth: '120px',
    'label-position': 'left',
    rules: {
      attendTime: [
        {
          required: true,
          message: '请选择时间',
          trigger: 'change',
        },
      ],
      content: [{ required: true, message: '请输入活动内容', trigger: 'blur' }],
      attendType: [
        {
          required: true,
          message: '请选择类别',
          trigger: 'change',
        },
      ],
      userType: [
        {
          required: true,
          message: '请选择参加人员',
          trigger: 'change',
        },
      ],
    },
  },
  items: [
    {
      type: 'datepicker',
      label: '时间',
      prop: 'attendTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      label: '活动内容',
      prop: 'content',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '类别',
      prop: 'attendType',
      options: dicts.attendType(),
    },
    {
      type: 'select',
      label: '参加人员',
      prop: 'userType',
      options: dicts.userType(),
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}

// 支部(党员)完成上级工作记录
export const branchWorkRecordCompleteCols = [
  {
    title: '时间',
    key: 'completeTime',
    tooltip: true,
    width: 150,
  },
  {
    title: '工作内容',
    key: 'content',
    tooltip: true,
    minWidth: 150,
  },
  {
    title: '负责人',
    key: 'headUser',
    minWidth: 160,
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 160,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchWorkRecordCompleteForm = {
  attrs: {
    labelWidth: '120px',
    'label-position': 'left',
    rules: {
      completeTime: [
        {
          required: true,
          message: '请选择时间',
          trigger: 'change',
        },
      ],
      content: [{ required: true, message: '请输入工作内容', trigger: 'blur' }],
      headUser: [
        { required: true, message: '请输入负责人', trigger: 'blur' },
      ],
    },
  },
  items: [
    {
      type: 'datepicker',
      label: '时间',
      prop: 'completeTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      label: '工作内容',
      prop: 'content',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '负责人',
      prop: 'headUser',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}
